import { useCallback } from 'react';
import { capturePublicApi } from '../api/captureApi';

interface PrivateFeedbackState {
  privateFeedback: string;
  patientName: string;
  patientContact: string;
}

interface PrivateFeedbackPatch {
  privateSending: boolean;
  privateDone: boolean;
}

/** Shared submit handler for the low-rating and happy-path capture flows' private feedback screen. */
export function usePrivateFeedbackSubmit(
  shortCode: string,
  rating: number | null,
  state: PrivateFeedbackState,
  set: (patch: Partial<PrivateFeedbackPatch>) => void,
) {
  return useCallback(async () => {
    // Contact info is required so the office can follow up — the screen keeps
    // Send disabled until all three fields are filled; this guards direct calls.
    if (!state.privateFeedback.trim() || !state.patientName.trim() || !state.patientContact.trim())
      return;
    set({ privateSending: true });
    try {
      await capturePublicApi.submitPrivate(
        shortCode,
        state.privateFeedback.trim(),
        rating ?? undefined,
        state.patientName.trim(),
        state.patientContact.trim(),
      );
      set({ privateDone: true, privateSending: false });
    } catch {
      set({ privateSending: false });
    }
  }, [shortCode, rating, state.privateFeedback, state.patientName, state.patientContact, set]);
}
